module.exports = __webpack_public_path__ + "img/building.70288e16.png";